export const GET_PRODUCT_CATEGORIES_REQUEST = "GET_PRODUCT_CATEGORIES_REQUEST"
export const GET_PRODUCT_CATEGORIES_SUCCESS = "GET_PRODUCT_CATEGORIES_SUCCESS"
export const GET_PRODUCT_CATEGORIES_FAILURE = "GET_PRODUCT_CATEGORIES_FAILURE"
export const GET_PRODUCT_LABELS_REQUEST = "GET_PRODUCT_LABELS_REQUEST"
export const GET_PRODUCT_LABELS_SUCCESS = "GET_PRODUCT_LABELS_SUCCESS"
export const GET_PRODUCT_LABELS_FAILURE = "GET_PRODUCT_LABELS_FAILURE"
